export default __webpack_public_path__ + "static/media/contractsold.897360c1.png";